// extracted by mini-css-extract-plugin
module.exports = {"background":"footer-module--background--Av0Hd"};